/* eslint-disable jsx-a11y/iframe-has-title */
import { Email, LocationOn, PhoneAndroid, Schedule } from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import useSectionView from "../hook/useSectionView";

const Contact = () => {
  const form = useRef();
  const sectionRef = useSectionView("Contacto");
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  const sendEmail = (e) => {
    e.preventDefault();
    setStatus("sending");
    emailjs
      .sendForm(
        "service_cyjhre2",
        "template_jib199m",
        form.current,
        "gT4MoJQ1uRLJiy1Kc"
      )
      .then(
        () => {
          form.current.reset();
          setStatus("success");
        },
        (error) => {
          console.error(error.text);
          setStatus("error");
        }
      );
  };

  return (
    <section id="Contacto" ref={sectionRef}>
      <Container maxWidth="lg" sx={{ marginTop: "20px", marginBottom: "20px" }}>
        <Grid container spacing={5}>
          <Grid item xs={12} md={6}>
            <Stack
              spacing={1}
              sx={{
                width: "100%",
                height: "100%",
                boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.2)",
                borderRadius: "10px",
                padding: "5px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "start",
                  flexDirection: "column",
                  gap: 1,
                  borderBottom: "1px solid #27AAE2",
                  padding: "15px",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ color: "#2A4E9C", fontWeight: 400, fontSize: "7pt" }}
                >
                  CONTACTO
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    color: "#2A4E9C",
                    fontWeight: 900,
                    letterSpacing: "1px",
                  }}
                >
                  DEJANOS TU CONSULTA
                </Typography>
                <Typography variant="body2" sx={{ color: "#2A4E9C" }}>
                  <PhoneAndroid sx={{ color: "#27AAE2", fontSize: 16, verticalAlign: "middle" }} />{" "}
                  Teléfono: 0341 399-9900
                </Typography>
                <Typography variant="body2" sx={{ color: "#2A4E9C" }}>
                  <Email sx={{ color: "#27AAE2", fontSize: 16, verticalAlign: "middle" }} /> Email:{" "}
                  <a
                    href="mailto:Info@lab-sertex.com.ar"
                    style={{ textDecoration: "none", color: "#2A4E9C" }}
                  >
                    Info@lab-sertex.com.ar
                  </a>
                </Typography>
                <Typography variant="body2" sx={{ color: "#2A4E9C" }}>
                  <LocationOn sx={{ color: "#27AAE2", fontSize: 16, verticalAlign: "middle" }} />{" "}
                  {
                    "Park Empresario - Altura, Calle 1910, Av. Uriburu Nº 4535 al 6800, S2000 Rosario, Santa Fe, Argentina"
                  }
                </Typography>
                <Typography variant="body2" sx={{ color: "#2A4E9C" }}>
                  <Schedule sx={{ color: "#27AAE2", fontSize: 16, verticalAlign: "middle" }} />{" "}
                  Horario de atención: Lunes a Viernes de 8:00 a 18:00 hs.
                </Typography>
              </Box>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3346.5569752792317!2d-60.7140808!3d-32.9890883!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95b7ad760ebe804d%3A0x5e1a0744678b6920!2sSertex%20S.R.L.!5e0!3m2!1ses!2ses!4v1697650433874!5m2!1ses!2ses"
                width="100%"
                height="100%"
                frameBorder="0"
                style={{ border: 0 }}
                allowFullScreen=""
                aria-hidden="false"
                tabIndex="0"
              ></iframe>
            </Stack>
          </Grid>
          <Grid item xs={12} md={6}>
            <Stack
              spacing={3}
              sx={{
                boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.2)",
                borderRadius: "10px",
                padding: "20px",
              }}
            >
              <Typography
                variant="h6"
                sx={{ color: "#2A4E9C", fontWeight: 900, letterSpacing: "1px" }}
              >
                Formulario de contacto
              </Typography>
              <form ref={form} onSubmit={sendEmail}>
                <Box
                  sx={{
                    mb: "23px",
                    display: "flex",
                    gap: 4,
                    justifyContent: "space-between",
                  }}
                >
                  <TextField name="name" label="Nombre" fullWidth required autoComplete="given-name" />
                  <TextField name="lastName" fullWidth label="Apellido" required autoComplete="family-name" />
                </Box>

                <Box
                  sx={{
                    mb: "23px",
                    display: "flex",
                    gap: 4,
                    justifyContent: "space-between",
                  }}
                >
                  <TextField name="interprice" fullWidth label="Empresa" autoComplete="organization" />
                </Box>

                <Box
                  sx={{
                    mb: "23px",
                    display: "flex",
                    gap: 4,
                    justifyContent: "space-between",
                  }}
                >
                  <TextField
                    name="email"
                    type="email"
                    fullWidth
                    label="Email"
                    required
                    autoComplete="email"
                  />
                </Box>
                <Box
                  sx={{
                    mb: "23px",
                    display: "flex",
                    gap: 4,
                    justifyContent: "space-between",
                  }}
                >
                  <TextField name="phone" label="Telefono" type="tel" fullWidth autoComplete="tel" />
                </Box>
                <Box
                  sx={{
                    mb: "23px",
                    display: "flex",
                    gap: 4,
                    justifyContent: "space-between",
                  }}
                >
                  <TextField
                    name="msg"
                    multiline
                    minRows={4}
                    fullWidth
                    label="Mensaje"
                    required
                  />
                </Box>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    variant="contained"
                    type="submit"
                    disabled={status === "sending"}
                    startIcon={
                      status === "sending" ? (
                        <CircularProgress size={16} color="inherit" />
                      ) : undefined
                    }
                    sx={{
                      backgroundColor: "#2A4E9C",
                      color: "#fff",
                      "&:hover": {
                        backgroundColor: "#27AAE2",
                      },
                    }}
                  >
                    {status === "sending" ? "Enviando..." : "Enviar Mensaje"}
                  </Button>
                </Box>
              </form>
            </Stack>
          </Grid>
        </Grid>

        <Snackbar
          open={status === "success" || status === "error"}
          autoHideDuration={5000}
          onClose={() => setStatus("idle")}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={() => setStatus("idle")}
            severity={status === "success" ? "success" : "error"}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {status === "success"
              ? "¡Mensaje enviado! Te responderemos a la brevedad."
              : "No pudimos enviar tu mensaje. Probá de nuevo o escribinos a Info@lab-sertex.com.ar."}
          </Alert>
        </Snackbar>
      </Container>
    </section>
  );
};

export default Contact;
